/**
 * import Vue
 * ※vueを使用しない場合は削除する
 */
// import App from './vue/App.js';

/**
 * import node_modules
 */
import 'desvg';
import objectFitImages from 'object-fit-images';
import picturefill from 'picturefill';
import SmoothScroll from 'smooth-scroll';
import 'modaal';

/**
 * import modules
 */
 import Search from './modules/search';
import SpMenu from './modules/spMenu';
import PcMenu from './modules/pcMenu';
import FontSize from './modules/fontSize';
import PageTop from './modules/pageTop';
import Consultation from './modules/consultation';

/**
 * Mainクラス
 * @constructor
 */
class Main {
  constructor() {
    this.setup();
  }
  /**
   * インスタンス生成時に実行する処理
   */
  setup() {
    document.addEventListener('DOMContentLoaded', () => {
      this.created();

    })
    window.addEventListener('load', () => {
      this.mounted();
    });
  }
  /**
   * ページ読み込み時に実行する処理
   */
  created() {
    picturefill();

    const spMenu = new SpMenu();
    spMenu.init();

    const pcMenu = new PcMenu();
    pcMenu.init();

    const fontSize = new FontSize();
    fontSize.init();

    const pageTop = new PageTop();
    pageTop.init();

    const search = new Search();
    search.init();

    const consultation = new Consultation();
    consultation.init();
  }
  /**
   * 画像読み込み後に実行する処理
   */
  mounted() {


    this.init_deSVG('.js-desvg');

    this.init_objectFitImages('.object-fit');

    this.init_smoothScroll();

    this.init_modaal();
  }


  init_modaal(){

    //動画リスト
    //働き方改革の意義
    $('.modal-movie01').modaal({
      content_source: '#modal-movie01',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/c3gEoj2Wl4g?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //時間外労働の上限規制①法改正内容について
    $('.modal-movie02').modaal({
      content_source: '#modal-movie02',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/6n9ooWV5vQU?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //時間外労働の上限規制②36協定届記載のポイント
    $('.modal-movie03').modaal({
      content_source: '#modal-movie03',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/A_K0Bz7pn74?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //年5日の年次有給休暇の確実な取得について
    $('.modal-movie04').modaal({
      content_source: '#modal-movie04',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/ldh1DmGlTmQ?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //働き方改革推進支援センターについて
    $('.modal-movie05').modaal({
      content_source: '#modal-movie05',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/ROcVd78MD2A?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //同一労働同一賃金（パートタイム労働者・有期雇用労働者編）
    $('.modal-movie06').modaal({
      content_source: '#modal-movie06',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/S-2_vdnVXZs?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //同一労働同一賃金（派遣労働者編）
    $('.modal-movie07').modaal({
      content_source: '#modal-movie07',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/8eTOy80XLvQ?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //フレックスタイム制、勤務間インターバル制度について
    $('.modal-movie08').modaal({
      content_source: '#modal-movie08',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/rnmkDYEHlhA?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //労務管理のポイントについて
    $('.modal-movie09').modaal({
      content_source: '#modal-movie09',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/7Fz1wxmpJRI?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //東京フォーラム
    $('.modal-eventMovie01').modaal({
      content_source: '#modal-eventMovie01',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/scjj0c24YW4?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //大阪フォーラム
    $('.modal-eventMovie02').modaal({
      content_source: '#modal-eventMovie02',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/nCUBxb_aZts?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //福岡フォーラム
    $('.modal-eventMovie03').modaal({
      content_source: '#modal-eventMovie03',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/xPvyP8csvRU?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //山形陸運株式会社
    $('.modal-coMovie01').modaal({
      content_source: '#modal-coMovie01',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/WwM5EP4HHJw?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //株式会社小田島組
    $('.modal-coMovie02').modaal({
      content_source: '#modal-coMovie02',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/wgNuTRYmW0g?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

    //田代珈琲株式会社
    $('.modal-coMovie03').modaal({
      content_source: '#modal-coMovie03',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/RVOpKvBQXO8?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });
    
    //田代珈琲株式会社
    $('.modal-coMovie04').modaal({
      content_source: '#modal-coMovie04',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/EeyC7pl5POE?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });
    
    //我が社の働き方改革～本橋テープ株式会社～
    $('.modal-coMovie04').modaal({
      content_source: '#modal-coMovie04',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/EeyC7pl5POE?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });
    
    //我が社の働き方改革～本橋テープ株式会社～
    $('.modal-coMovie04').modaal({
      content_source: '#modal-coMovie04',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/EeyC7pl5POE?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });
    
    //我が社の働き方改革～株式会社サニックス～
    $('.modal-coMovie05').modaal({
      content_source: '#modal-coMovie05',
      after_open: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', 'https://www.youtube.com/embed/yipOXvnMSUA?autoplay=1&mute=1');
      } ,
      before_close: function(modal_wrapper) {
        $('.modal-video iframe').attr('src', '');
      }
    });

  }

  /**
   * ライブラリ/deSVG
   * インラインsvgをsvgタグに変換
   * https://github.com/benhowdle89/deSVG
   * @param {Element} target ターゲットとなる要素
   */
  init_deSVG(target) {
    deSVG(target, true)
  }

  /**
   * ライブラリ/object-fit-images
   * css object-fit のポリフィル
   * https://github.com/fregante/object-fit-images
   * @param {Element} target ターゲットとなる要素
   */
  init_objectFitImages(target) {
    objectFitImages(target);
  }

  /**
   * ライブラリ/picturefill
   * html pictureタグのポリフィル
   * https://scottjehl.github.io/picturefill/
   */
  init_picturefill() {
    picturefill();
  }

  /**
   * ライブラリ/smooth-scroll
   * スムーススクロール
   * https://github.com/cferdinandi/smooth-scroll
   */
  init_smoothScroll() {
    /**
     * ターゲットとなる要素
     * @type {Element}
     */
    const targetElement = 'a[href*="#"]';

    /**
     * オプション
     * @type {object}
     */
    const option = {
      speed: 1000,
      easing: 'easeInOutCubic',
      speedAsDuration: true,
      //header: '.l-header' 固定ヘッダーの場合
    }

    new SmoothScroll(targetElement, option);
  }
}

export default new Main();
